import { appApiHeaders, getApiUrl } from '@/utils/api-utils'
import { apiCall } from '@ngtrvu/use-api'

const FETCH_NAV_ITEM = 'FETCH_NAV_ITEM'
const FETCH_NAV_ITEMS = 'FETCH_NAV_ITEMS'

export const getNavItemApi = apiCall(
  FETCH_NAV_ITEM,
  ({ siteId, id }: { siteId: string; id: string }) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/nav-items/${id}`),
    method: 'GET',
    headers: appApiHeaders(),
  }),
)

export const getNavItemsApi = apiCall(
  FETCH_NAV_ITEMS,
  ({ siteId }: { siteId: string }) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/nav-items`),
    method: 'GET',
    headers: appApiHeaders(),
  }),
)
